import React from 'react'
import { styled } from '@mui/material/styles'
// import { TextField } from '@material-ui/core'
import { getDayAndMonthFromLabel } from 'services/utils/date'
import {
  DayMonthLabel,
  MonthLabel,
  NullableWithDayAndMonth,
} from 'types/common'
import { monthChoices } from 'services/cfg/form'
import { Labeled, TextField } from 'react-admin'
const PREFIX = 'DayMonthField'

const classes = {
  inline: `${PREFIX}-inline`,
  hide: `${PREFIX}-hide`,
  sectionTitle: `${PREFIX}-sectionTitle`,
  divider: `${PREFIX}-divider`,
  productFieldsContainer: `${PREFIX}-productFieldsContainer`,
  fullWidth: `${PREFIX}-fullWidth`,
  flexColumn: `${PREFIX}-flexColumn`,
  defaultWidth: `${PREFIX}-defaultWidth`,
  width160: `${PREFIX}-width160`,
  arrayInputPadding: `${PREFIX}-arrayInputPadding`,
  mr16: `${PREFIX}-mr16`,
  flexCenter: `${PREFIX}-flexCenter`,
  mt20: `${PREFIX}-marginBottom`,
}

const Root = styled('div')(({ theme }: any) => ({
  [`& .${classes.inline}`]: { display: 'inline-flex' },

  [`& .${classes.hide}`]: {
    height: '0px',
    width: '0px',
    visibility: 'hidden',
  },

  [`& .${classes.sectionTitle}`]: {
    fontWeight: 'bold',
    fontSize: '20px',
    marginTop: '4px',
  },

  [`& .${classes.divider}`]: {
    width: '100%',
    height: '3px',
    backgroundColor: theme.palette.primary.light,
    marginTop: '20px',
  },

  [`& .${classes.productFieldsContainer}`]: {
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.fullWidth}`]: {
    width: '100%',
  },

  [`& .${classes.flexColumn}`]: {
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.defaultWidth}`]: {
    width: '256px',
  },

  [`& .${classes.width160}`]: {
    width: '160px',
  },

  [`& .${classes.arrayInputPadding}`]: {
    padding: '16px 0 0 0',
  },

  [`& .${classes.mr16}`]: {
    marginRight: '16px',
  },

  [`& .${classes.flexCenter}`]: {
    display: 'flex',
    justifyContent: 'center',
  },
  [`& .${classes.mt20}`]: {
    marginTop: '20px',
  },
}))

type Props = {
  label: string
  value?: DayMonthLabel
  style?: React.CSSProperties
}

const NULL_DAY_AND_MONTH: NullableWithDayAndMonth = { day: '', month: '' }

const getMonthLabelFromId = (id: MonthLabel | '') =>
  monthChoices.find((c) => c.id === id)?.name

const DayMonthField: React.FC<Props> = ({ value, label, style }) => {
  const { day, month } = value
    ? getDayAndMonthFromLabel(value)
    : NULL_DAY_AND_MONTH

  const RECORD = { id: 1, day, month: getMonthLabelFromId(month) }

  return (
    <Root style={{ margin: '16px 16px 16px 0' }}>
      {label}
      <div
        className={classes.mt20}
        style={{ display: 'flex', alignItems: 'center', ...style }}
      >
        <Labeled
          label="Month"
          className={`${classes.mr16} ${classes.width160}`}
        >
          <TextField record={RECORD} source="month" />
        </Labeled>
        <Labeled label="Day" className={classes.width160}>
          <TextField record={RECORD} source="day" />
        </Labeled>
      </div>
    </Root>
  )
}

export default DayMonthField
